import {
  FoodDetailsContent,
  FoodDetailsHeader,
  FoodDetailsInfo,
  StyledFoodDetails,
} from "./styled"
import { BackButton } from "components/Common/BackButton"
import NutrientInformation from "components/foodDetails/share/NutrientInformation"
import Button from "components/Buttons/Button"
import CtaBox from "components/Common/CtaBox"
import TrashIcon from "components/Icons/TrashIcon"
import FoodImage from "components/foodDetails/share/FoodImage"
import { useState } from "react"
import ChevronLeftBtn from "components/Icons/ChevronLeftBtn"
import AIIngredientNameAndPortion from "./AIIngredientNameAndPortion"
import { IAIScanIngredientOption } from "model/food/types/AIScan.types"
import { updateNonIngredientEntryNutritionWhenPortionChange } from "features/food/helper/edamaForm"
import AppStyleCtaBox from "components/Common/AppStyleCtaBox"

interface IAIIngredientDetailsProps {
  onBack: () => void
  ingredient: IAIScanIngredientOption
  onEdit: (ingredient: IAIScanIngredientOption) => void
  onDelete: (id: string) => void
}

const AIIngredientDetails = (props: IAIIngredientDetailsProps) => {
  const { onBack, ingredient, onEdit, onDelete } = props

  const [localIngredient, setLocalIngredient] = useState(ingredient)
  const [isPortionValid, setIsPortionValid] = useState(true)

  const onPortionChange = (portion: number) => {
    const nutrition = updateNonIngredientEntryNutritionWhenPortionChange(
      localIngredient,
      portion,
    )
    setLocalIngredient({ ...localIngredient, portion, ...nutrition })
  }

  const onPortionChangeHandler = (value: number) => {
    onPortionChange(value)
    setIsPortionValid(true)
  }

  return (
    <StyledFoodDetails>
      <FoodDetailsContent>
        <FoodImage>
          <FoodDetailsHeader>
            <BackButton onClick={onBack}>
              <ChevronLeftBtn />
            </BackButton>
          </FoodDetailsHeader>
        </FoodImage>

        <FoodDetailsInfo>
          <AIIngredientNameAndPortion
            ingredient={localIngredient}
            unit={localIngredient.unit}
            portionValue={localIngredient.portion}
            onPortionChange={onPortionChangeHandler}
            setIsPortionValid={setIsPortionValid}
            calories={localIngredient.calorie}
          />

          <NutrientInformation entry={localIngredient} />
        </FoodDetailsInfo>
      </FoodDetailsContent>
      
      <AppStyleCtaBox style={{ marginTop: "auto" }}>
        <Button
          onClick={() => onDelete(ingredient.uuid)}
          $type="default"
          $isDeleteBtn
          style={{
            padding: "var(--spacing_m, 12px) var(--spacing_l, 16px)",
          }}
        >
          <TrashIcon color="#FF4921" />
        </Button>

        <Button
          disabled={!isPortionValid}
          style={{ width: "100%" }}
          $type="primary"
          onClick={() => {
            onEdit(localIngredient)
            onBack()
          }}
        >
          Save
        </Button>
      </AppStyleCtaBox>
    </StyledFoodDetails>
  )
}

export default AIIngredientDetails
